/** Engaging Content whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { engacontDefaultTheme } from './default';

export { engacontWhitelabel } from './default';

export const engacontWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: engacontDefaultTheme,
  },
};
